export default "__VITE_ASSET__b8b988de__"